import React, { useState } from 'react';
import { createContact } from '../../service/api';

export default function ContactForm() {
  const [form, setForm] = useState({
    fullName: '',
    phone: '',
    address: '',
    email: '',
    content: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.fullName || !form.phone || !form.content) {
      setError('Vui lòng điền đầy đủ thông tin bắt buộc');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await createContact(form);
      setSuccess(true);
      setForm({ fullName: '', phone: '', address: '', email: '', content: '' });
    } catch (err) {
      setError('Gửi liên hệ thất bại. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='cs_contact_form cs_style_1 cs_white_bg cs_radius_30'>
      <h3 className='cs_fs_24 cs_semibold' style={{ marginBottom: '24px' }}>
        Điền thông tin liên hệ
      </h3>
      {success && (
        <div style={{ padding: '12px 16px', background: '#e6f7e6', borderRadius: '8px', marginBottom: '20px', color: '#2e7d32' }}>
          Gửi liên hệ thành công! Chúng tôi sẽ phản hồi sớm nhất.
        </div>
      )}
      {error && (
        <div style={{ padding: '12px 16px', background: '#ffeaea', borderRadius: '8px', marginBottom: '20px', color: '#d32f2f' }}>
          {error}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-lg-6'>
            <label className='cs_input_label cs_heading_color'>Họ tên<span style={{ color: 'red' }}>*</span></label>
            <input
              type='text'
              name='fullName'
              className='cs_form_field'
              placeholder='Nhập họ tên'
              value={form.fullName}
              onChange={handleChange}
            />
            <div className='cs_height_42 cs_height_xl_25' />
          </div>
          <div className='col-lg-6'>
            <label className='cs_input_label cs_heading_color'>Điện thoại<span style={{ color: 'red' }}>*</span></label>
            <input
              type='text'
              name='phone'
              className='cs_form_field'
              placeholder='Nhập số điện thoại'
              value={form.phone}
              onChange={handleChange}
            />
            <div className='cs_height_42 cs_height_xl_25' />
          </div>
          <div className='col-lg-6'>
            <label className='cs_input_label cs_heading_color'>Địa chỉ</label>
            <input
              type='text'
              name='address'
              className='cs_form_field'
              placeholder='Nhập địa chỉ'
              value={form.address}
              onChange={handleChange}
            />
            <div className='cs_height_42 cs_height_xl_25' />
          </div>
          <div className='col-lg-6'>
            <label className='cs_input_label cs_heading_color'>Email</label>
            <input
              type='email'
              name='email'
              className='cs_form_field'
              placeholder='Nhập email'
              value={form.email}
              onChange={handleChange}
            />
            <div className='cs_height_42 cs_height_xl_25' />
          </div>
          <div className='col-lg-12'>
            <label className='cs_input_label cs_heading_color'>Nội dung<span style={{ color: 'red' }}>*</span></label>
            <textarea
              name='content'
              cols={30}
              rows={5}
              className='cs_form_field'
              placeholder='Nhập nội dung liên hệ'
              value={form.content}
              onChange={handleChange}
            />
            <div className='cs_height_42 cs_height_xl_25' />
          </div>
          <div className='col-lg-12'>
            <div className='cs_height_18' />
            <button className='cs_btn cs_style_1' type='submit' disabled={loading}>
              <span>{loading ? 'Đang gửi...' : 'Gửi liên hệ'}</span>
              <i>
                <img src='/images/icons/arrow_white.svg' alt='Icon' />
                <img src='/images/icons/arrow_white.svg' alt='Icon' />
              </i>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
